import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=fe00b6fa&scoped=true"
import script from "./AddRole.vue?vue&type=script&lang=ts"
export * from "./AddRole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe00b6fa",
  null
  
)

export default component.exports